import { httpRequest } from "@services/http";
import { Comment } from "@models/comment.model";
import { CommentSerializer } from "@models/serializers/CommentSerializer";

export class CommandGetAdComments {
  async run(adId: number) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/${adId}/comments/`;
    const response = await httpRequest<any>(url, { method: "GET" });
    return this.deserialize(response.comments);
  }

  deserialize(data: any): Comment[] {
    const serializer = new CommentSerializer();
    return serializer.deserializeList(data);
  }
}
